<template>
  <div>
    <a-card :bordered="false">
      <div class="bonus-header">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24" type="flex" align="top" class="select-container">
            <a-col :md="6" :sm="12">
              <a-form-item label="产品名称:">
                <a-input
                  placeholder="请输入分组名称"
                  v-model="fundName"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="16" :sm="8">
              <span
                style="float: left; overflow: hidden"
                class="table-page-search-submitButtons"
              >
                <a-button type="primary" @click="searchQuery" icon="search"
                  >查询</a-button
                >
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 8px"
                  >重置</a-button
                >
              </span>
            </a-col>
            <a-col :md="2" :sm="8">
              <a-button @click="goBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator">
        <a-button @click="addProduct" type="primary" icon="plus"
          >添加产品</a-button
        >

        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />批量删除</a-menu-item
            >
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <div class="table">
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
        <a-table
          bordered
          :columns="columns"
          :data-source="prouuctArr"
          rowKey="fundCode"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <!-- <a @click="handleDetail(record)">详情</a>
            <a-divider type="vertical" /> -->

            <a @click="handleDel(record.fundCode)">删除</a>
          </span>
        </a-table>
      </div>
      <product-add
        ref="productAdd"
        @initProductList="initProductList"
      ></product-add>
    </a-card>
  </div>
</template>
<script>
import {
  deleteFundFromGroupByGroupIdAndFundCodes,
  getProductListByAppointProductGroup,
  deleteGroup,
} from '@/api/product';
import productAdd from './productById.vue';
const columns = [
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    scopedSlots: { customRender: 'fundCode' },
    width: 300,
  },
  // { title: '产品规模', align: 'center', dataIndex: 'productScale', width: 100 },
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
  },

  {
    title: '操作',
    key: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  data() {
    return {
      groupId: '',
      fundName: '', //产品名称
      columns,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      loading: false,
      prouuctArr: [],
      selectedRowKeys: [],
    };
  },

  created() {
    // this.initProductList();
  },
  components: {
    productAdd,
  },
  methods: {
    //
    batchDel() {
      this.handleDel(this.selectedRowKeys);
    },
    handleDel(ids) {
      let idsArr = [];
      if (Array.isArray(ids)) {
        idsArr = ids;
      } else {
        idsArr.push(ids);
      }
      let params = {
        fundGroupId: this.groupId,
        fundCodes: idsArr,
      };
      deleteFundFromGroupByGroupIdAndFundCodes(params).then((res) => {
        if (res.success) {
          this.$message.success('操作成功');
          this.initProductList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //返回上一夜
    goBack() {
      this.$emit('close', false);
    },
    getFundInfo(records) {
      console.log(records);
      this.groupId = records.id;
      this.$nextTick(() => {
        this.initProductList(1);
      });
    },
    //查看产品
    handleDetail() {
      this.productDetailsShow = true;
    },
    //批量操作选择的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
      console.log(this.selectedRowKeys);
    },

    //编辑
    confirmCopyProduct(records) {
      this.$refs.modalField.edit(records);
    },
    //搜索
    searchQuery(e) {
      e.preventDefault();
      this.initProductList(1);
    },

    //重置
    searchReset() {
      this.fundName = '';
      this.initProductList(1);
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    //table数据
    initProductList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }

      let params = `groupId=${this.groupId}&pageNo=${this.ipagination.current}&pageSize=${this.ipagination.pageSize}&fundName=${this.fundName}`;
      that.loading = true;
      getProductListByAppointProductGroup(params).then((res) => {
        that.loading = false;
        if (res.success) {
          that.prouuctArr =
            res.result && res.result.list ? res.result.list : [];

          that.loading = false;
          that.ipagination.total = res.result.total;
        }
      });
    },

    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initProductList();
    },

    //添加产品
    addProduct() {
      this.$refs.productAdd.handleAddVisible(this.groupId);
    },
  },
};
</script>
<style scoped lang="less">
.table-operator {
  margin: 20px 0;
}
</style>
